window.MiceAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    var headerSettings;

    self.getColorScheme = function (brandId) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/scheme_settings', 'GET')
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };

    self.updateColorScheme = function (brandId, payload) {
        var deferred = $q.defer();
        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/scheme_settings', 'PUT', payload)
            .then(function (data) {
                if (data && data.data && data.data.data) {
                    headerSettings = null;
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandMedia = function (brandId, payload) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/media', 'GET', payload)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.data.media) {
                        deferred.resolve(res.data.data.media);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };

    self.getMediaFileUrl = function (brandId, payload) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/media/presigned_url', 'GET', payload)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.data.href) {
                        deferred.resolve(res.data.data.href);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };

    self.uploadMedia = function (brandId, media) {
        if(!media){
            throw 'media object is required';
        }
        var deferred = $q.defer();
        var request = 'brands/' + brandId + '/media';
        if (media.id) {
            request += ('/' + media.id);
        }

        var params = {
            title: media.title || '',
            description: media.description || '',
            type: media.type,
            format: media.format,
            path: media.path,
            is_hosted: media.format === 'VIDEO' ? !!media.is_hosted : false
        };

        var media_secondary = [];
        if (media.media_secondary) {
            media.media_secondary.forEach(function (item, index) {
                var mediaSecondaryParams = {
                    type: item.type || media.format,
                    order: index + 1,
                    path: item.path
                };
                if (item.id) {
                    mediaSecondaryParams.id = item.id;
                }
                if(item.name){
                    mediaSecondaryParams.name = item.name;
                }
                media_secondary.push(mediaSecondaryParams);
            });
        }

        if(media_secondary.length){
            params['media_secondary'] = media_secondary;
        }

        if (media.positions && media.positions.length) {
            var positionIds = _.map(media.positions, function (position) {
                return {code: position.code};
            });
            params.positions = positionIds;
        }
        _protected.request(request, media.id ? 'PUT' : 'POST', params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code === 200 ) {
                        if(media.type === 'profile_image'){
                            headerSettings = null;
                        }
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res.data.data);
                    }
                })
            .catch(function (err) {
                deferred.reject(err.data.data);
            });
        return deferred.promise;
    };

    self.deleteMedia = function (brandId, id) {
            var defer = $q.defer();
            _protected.request('brands/' + brandId + '/media/' + id, 'DELETE')
                .then(function (response) {
                    if (response.data && response.data.data && response.status === 200) {
                        defer.resolve(response.data.data);

                    } else {
                        defer.reject(response);
                    }
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;

    };

    self.removeJobMedia = function (brandId, jobMediaId) {
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/media/' + jobMediaId, 'DELETE')
            .then(function (res) {
                    if (res.data && res.data.status_code === 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };

    self.getEmployerMediaBranding = function () {
        var deferred = $q.defer();
        if (headerSettings) {
            deferred.resolve(headerSettings);
        } else {
            _protected.request('employers/profile_scheme', 'GET')
                .then(function (res) {
                        if (res.data && res.data.status_code === 200) {
                            headerSettings = res.data.data;
                            deferred.resolve(res.data.data);
                        } else {
                            deferred.reject(res);
                        }
                    },
                    function (err) {
                        deferred.reject(err);
                    });
        }
        return deferred.promise;
    };

    self.getCandidateMediaBranding = function () {
        var deferred = $q.defer();
        if (headerSettings) {
            deferred.resolve(headerSettings);
        } else {
            _protected.request('js_dashboard/profile_scheme', 'GET')
                .then(function (res) {
                        if (res.data && res.data.status_code === 200) {
                            headerSettings = res.data.data;
                            deferred.resolve(headerSettings);
                        } else {
                            deferred.reject(res);
                        }
                    },
                    function (err) {
                        deferred.reject(err);
                    });
        }
        return deferred.promise;
    };
});
